import { bl_inv_stock_replenishment_run_order_fulfillment_line_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class StockReplenishmentRunOrderFulfillmentLineModel extends BaseContainerModel {
    bl_inv_stock_replenishment_run_order_fulfillment_line: bl_inv_stock_replenishment_run_order_fulfillment_line_RowClass = new bl_inv_stock_replenishment_run_order_fulfillment_line_RowClass();
}
